import { applicantConstants } from "../constants";

export const applicant = (state = {}, action) => {
  switch (action.type) {
    case applicantConstants.CREATE_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.CREATE_SUCCESS:
      return {
        ...state,
        newApplicant: action.applicant,
      };
    case applicantConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case applicantConstants.CANDIDATE_REFERRAL_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.CANDIDATE_REFERRAL_SUCCESS:
      return {
        ...state,
        newApplicant: action.applicant,
      };
    case applicantConstants.CANDIDATE_REFERRAL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case applicantConstants.CREATEEXTERNAL_REQUEST:
      return state;
    case applicantConstants.CREATEEXTERNAL_SUCCESS:
      return {
        ...state,
        externalApplicant: action.applicant,
      };
    case applicantConstants.CREATEEXTERNAL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case applicantConstants.UPDATE_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.UPDATE_SUCCESS:
      return {
        ...state,
      };
    case applicantConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case applicantConstants.DELETE_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.DELETE_SUCCESS:
      return {
        ...state,
      };
    case applicantConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.GETHISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case applicantConstants.GETHISTORY_SUCCESS:
      return {
        ...state,
        history: action.history,
        loading: false,
      };
    case applicantConstants.GETHISTORY_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.GETCOMMENT_REQUEST:
      return {
        ...state,
        commentLoading: true,
      };
    case applicantConstants.REMOVECOMMENTS:
      return {
        ...state,
        commentData: [],
      };
    case applicantConstants.GETCOMMENT_SUCCESS:
      return {
        ...state,
        commentData: action.comment,
        commentLoading: false,
      };
    case applicantConstants.GETCOMMENT_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.CREATECOMMENT_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.CREATECOMMENT_SUCCESS:
      return {
        ...state,
        commentData:
          state.commentData && state.commentData.length > 0
            ? [action.comment].concat(state.commentData)
            : [action.comment],
      };
    case applicantConstants.CREATECOMMENT_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.UPDATECOMMENT_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.UPDATECOMMENT_SUCCESS:
      const indexComment =
        state.commentData &&
        state.commentData.findIndex(
          (comment) => comment.id === action.comment.id
        );
      return {
        ...state,
        commentData:
          state.commentData &&
          state.commentData.map((el, index) =>
            index === indexComment ? { ...el, ...action.comment } : el
          ),
      };
    case applicantConstants.UPDATECOMMENT_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.DELETECOMMENT_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.DELETECOMMENT_SUCCESS:
      const commentData =
        state.commentData &&
        state.commentData.filter((comment) => comment.id !== action.id);

      return {
        ...state,
        commentData: commentData,
      };
    case applicantConstants.DELETECOMMENT_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.GETSUMMARY_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.GETSUMMARY_SUCCESS:
      return {
        ...state,
        profileSummary: action.profileSummary,
      };
    case applicantConstants.GETSUMMARY_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.GETCHARTSUMMARY_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.GETCHARTSUMMARY_SUCCESS:
      return {
        ...state,
        chartSummary: action.chartSummary,
      };
    case applicantConstants.GETCHARTSUMMARY_FAILURE:
      return {
        error: action.error,
      };

    case applicantConstants.GETEXTERNALDATA_REQUEST:
      return {
        ...state,
        externalLoader: true,
      };
    case applicantConstants.GETEXTERNALDATA_SUCCESS:
      return {
        ...state,
        externalData: action.externalData,
        externalLoader: false,
      };
    case applicantConstants.GETEXTERNALDATA_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.GETBOARDDATA_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.GETBOARDDATA_SUCCESS:
      return {
        ...state,
        boardData: action.board,
      };
    case applicantConstants.GETBOARDDATA_FAILURE:
      return {
        error: action.error,
      };
    case applicantConstants.UPDATESTATUS_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.UPDATESTATUS_SUCCESS:
      return {
        ...state,
      };
    case applicantConstants.UPDATESTATUS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case applicantConstants.GETSTATUSDATA_REQUEST:
      return {
        ...state,
      };
    case applicantConstants.GETSTATUSDATA_SUCCESS:
      return {
        ...state,
        applicantStatus: action?.applicantStatus,
      };
    case applicantConstants.GETSTATUSDATA_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case applicantConstants.GETALL_REQUEST:
      return {
        ...state,
        BoardCardLoading: true,
      };
    case applicantConstants.GETALL_SUCCESS:
      return {
        ...state,
        boardApplicant: action?.boardApplicant,
        BoardCardLoading: false,
      };
    case applicantConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};
